import axios from '@/util/request';

export function getProject(parameter) {
  //资料管理-项目信息列表
  return axios({
    url: '/ims/project/page',
    method: 'get',
    params: parameter,
  })
}

export function createProject(parameter) {
  //资料管理-添加项目
  return axios({
    url: '/ims/project',
    method: 'post',
    data: parameter
  })
}

export function delProject(id) {
  //资料管理-删除项目
  return axios({
    url: '/ims/project/' + id,
    method: 'DELETE',
  })
}

export function updateProject(parameter) {
  //资料管理-更新项目
  return axios({
    url: '/ims/project',
    method: 'put',
    data: parameter
  })
}

export function getExdoc(parameter) {
  //资料管理-申请单导出记录
  return axios({
    url: '/ims/UseManage/ExportByUseApplication',
    method: 'get',
    params: parameter,
  })
}

export function getExdo(parameter) {
  //资料管理-仪器导出使用记录
  return axios({
    url: '/ims/UseManage/ExportByIns',
    method: 'get',
    params: parameter,
  })
}

export function getExd(parameter) {
  //资料管理-项目导出仪器使用记录
  return axios({
    url: '/ims/UseManage/ExportByProject',
    method: 'get',
    params: parameter,
  })
}

export function getAppList(parameter) {
  //申请管理-申请单列表
  return axios({
    url: '/ims/UseApply/getUseApplyList',
    method: 'get',
    params: parameter,
  })
}
export function getAppListv2(parameter) {
  //申请管理-申请单列表
  return axios({
    url: '/ims/applyInstrument/page',
    method: 'get',
    params: parameter,
  })
}


export function exAppList(parameter) {
  //申请管理-导出出入库记录
  return axios({
    url: '/ims/useInfo/exportByApply',
    method: 'post',
    responseType: 'blob',
    data: parameter,
    timeout: 60 * 60 * 1000,
  })
}

export function returnIns(parameter) {
  //管理员设置仪器归还
  return axios({
    url: '/ims/UseApply/sendBack',
    method: 'put',
    params: parameter,
  })
}

export function takeOutIns(parameter) {
  //管理员设置仪器取出
  return axios({
    url: '/ims/UseApply/takeOut',
    method: 'put',
    params: parameter,
  })
}
///ims/project/exportUseInfo
export function exportByProjectId(parameter) {
  //项目管理-导出出入库记录
  return axios({
    url: '/ims/project/exportByProjectId',
    method: 'get',
    responseType: 'blob',
    params: parameter,
    timeout: 60 * 60 * 1000,
  })
}

export function secondExportByProjectId(parameter) {
  //项目管理-使用记录
  return axios({
    url: '/ims/project/exportUseInfo',
    method: 'get',
    responseType: 'blob',
    params: parameter,
    timeout: 60 * 60 * 1000,
  })
}

export function exportFixedByApply(parameter) {
  //申请管理-导出出入库记录
  return axios({
    url: '/ims/useInfo/exportFixedByApply',
    method: 'post',
    responseType: 'blob',
    data: parameter,
    timeout: 60 * 60 * 1000,
  })
}

export function getListHistoryProject(projectId) {
  //历史项目数据
  return axios({
    url: '/ims/project/listHistoryProject/' + projectId,
    method: 'get',
  })
}

///ims/project/importProject
export function importProject(parameter) {
  //资料管理-添加项目
  return axios({
    url: '/ims/project/importProject',
    method: 'post',
    data: parameter
  })
}



// WEBPACK FOOTER //
// ./src/api/dataMana.js